import React from "react";
import { Check } from "lucide-react";

export default function Stepper({ steps, current, onStepClick }) {
  return (
    <ol
      className="flex sm:grid sm:grid-cols-7 gap-2 sm:gap-2 overflow-x-auto -mx-1 px-1 snap-x snap-mandatory"
      data-testid="application-stepper"
    >
      {steps.map((s, idx) => {
        const isActive = idx === current;
        const isCompleted = idx < current;
        const cls = isActive
          ? "border-blue-900 text-blue-900 bg-blue-50"
          : isCompleted
          ? "border-emerald-500 text-emerald-600 bg-emerald-50"
          : "border-slate-200 text-slate-400 bg-white";
        return (
          <li key={s.key} className="flex flex-col items-center text-center shrink-0 snap-start w-14 sm:w-auto">
            <button
              type="button"
              onClick={() => onStepClick && onStepClick(idx)}
              data-testid={`step-${s.key}`}
              className={`h-9 w-9 rounded-full border-2 grid place-items-center text-sm font-semibold transition-colors ${cls}`}
            >
              {isCompleted ? <Check className="h-4 w-4" /> : idx + 1}
            </button>
            <span className={`mt-1 text-[10px] sm:text-xs font-medium leading-tight ${isActive ? "text-blue-900" : isCompleted ? "text-emerald-600" : "text-slate-500"}`}>
              {s.label}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
